module.exports = __webpack_public_path__ + "img/cover_photo.b2a5ef19.jpg";